module.exports = __webpack_public_path__ + "img/05.1b0e40cc.png";